module.exports = __webpack_public_path__ + "static/media/sm-perfil.0c624272.png";